<script lang="ts">
	import Icon from '../icon/Icon.svelte'
	import TooltipContent from './TooltipContent.svelte'
	import { type IconSource, QuestionMarkCircle } from '@steeze-ui/heroicons'

	interface Props {
		block?: boolean
		disabled?: boolean
		small?: boolean
		autoWidth?: boolean
		icon?: IconSource
		iconClass?: string
		text?: string
		placeholder?: import('svelte').Snippet
		children?: import('svelte').Snippet
		left?: boolean
	}

	let {
		block = false,
		disabled = false,
		small = true,
		autoWidth = false,
		icon = QuestionMarkCircle,
		text = null,
		placeholder,
		children,
		left = false,
		iconClass = 'text-primary-500',
	}: Props = $props()

	let tooltipElement: HTMLElement = $state(null)

	let visible = $state(false)

	let timer: ReturnType<typeof setTimeout>

	function handleShow() {
		clearTimeout(timer)
		visible = true
	}

	function handleHide() {
		timer = setTimeout(() => {
			visible = false
		}, 200)
	}
</script>

{#if disabled}
	{@render placeholder?.()}
{:else}
	<div class={block ? 'contents' : 'inline-flex'}>
		<button
			bind:this={tooltipElement}
			class="{block ? 'w-full' : 'inline-flex'} cursor-auto text-left"
			onblur={handleHide}
			onfocus={handleShow}
			onmouseenter={handleShow}
			onmouseleave={handleHide}
			type="button"
		>
			{#if placeholder}{@render placeholder()}{:else}
				<Icon class={iconClass} {small} src={icon} />
			{/if}
		</button>

		{#if tooltipElement && visible}
			<TooltipContent
				{autoWidth}
				{left}
				onmouseenter={handleShow}
				onmouseleave={handleHide}
				{tooltipElement}
				bind:visible
			>
				<div class="font-normal">
					{#if text}{text}{:else}
						{@render children?.()}
					{/if}
				</div>
			</TooltipContent>
		{/if}
	</div>
{/if}
